import React, { useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { Button } from 'ui-components/components/button';

import style from '../../../../components/grid-header/reusable-grid-button.module.less';
import { useDataExportFeatureGate } from '../../../../feature-gates/use-data-export-feature-gate';
import { exportInventory } from '../../../../store/inventory/inventory.actions';
import messages from '../../messages';
import ConfirmActionModal from '../modals/export/export-form-modal';

/**
 * @returns {React.JSX.Element}
 */
const ExportButton = () => {
  const [shouldRenderModal, setShouldRenderModal] = useState(false);
  const dispatch = useDispatch();
  const { isFeatureEnabled, disabledMessage } = useDataExportFeatureGate();

  const onConfirm = useCallback(
    (data) => {
      dispatch(exportInventory(data));
      setShouldRenderModal(false);
    },
    [dispatch],
  );
  const openModal = useCallback(() => {
    setShouldRenderModal(true);
  }, []);
  const onClose = useCallback(() => {
    setShouldRenderModal(false);
  }, []);

  const disabledTooltipMessage = disabledMessage ? <FormattedMessage {...disabledMessage} /> : undefined;

  return (
    <>
      <Button
        className={style['reusable-button']}
        disabled={!isFeatureEnabled}
        disabledTooltipMessage={disabledTooltipMessage}
        onClick={openModal}
        theme='tertiary'
      >
        <FormattedMessage {...messages.exportButton} />
      </Button>
      {shouldRenderModal ? <ConfirmActionModal onClose={onClose} onConfirm={onConfirm} /> : null}
    </>
  );
};

export default ExportButton;
